import { render } from "./ScheduleDayMenuButtons.vue?vue&type=template&id=0ad0c335&scoped=true&ts=true"
import script from "./ScheduleDayMenuButtons.vue?vue&type=script&lang=ts"
export * from "./ScheduleDayMenuButtons.vue?vue&type=script&lang=ts"

import "./ScheduleDayMenuButtons.vue?vue&type=style&index=0&id=0ad0c335&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad0c335"]])

export default __exports__